import type { CheckboxProps } from '@mui/material';
import { forwardRef, memo } from 'react';
import { Checkbox } from '../../../../mui/common/Checkbox.tsx';
import type { ControllerRenderProps } from 'react-hook-form';
import { type FieldValues } from 'react-hook-form';

const CheckboxEditableBase = forwardRef<HTMLButtonElement, CheckboxProps & ControllerRenderProps<FieldValues>>((props, ref) => {
  return <Checkbox {...props} ref={ref} checked={props.value === 'false' ? false : Boolean(props.value)} />;
});

export const CheckboxEditable = memo(CheckboxEditableBase);
